import get from 'lodash/get';
import { ImageTypes } from '@scentregroup/shared/types/images';
const imageTypeToColorField = imageType => {
  switch (imageType) {
    case ImageTypes.Master:
      return 'masterSupportingColour';
    case ImageTypes.Standard:
      return 'standardSupportingColour';
    case ImageTypes.Square:
      return 'squareSupportingColour';
    default:
      return 'masterSupportingColour';
  }
};
const getEntryImageFromImageSet = (imageSet, imageType) => {
  const image = imageSet[imageType];
  const color = imageSet[imageTypeToColorField(imageType)];
  if (image) {
    return {
      alt: imageSet.description || image.description,
      src: image.url,
      imageType,
      supportingColor: color
    };
  } else {
    return {
      alt: '',
      src: '',
      imageType: null
    };
  }
};
const getImageFromEntry = function (entry, imageType) {
  let fallbackImageType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ImageTypes.Master;
  if (get(entry, "heroImageSet.".concat(imageType, ".url"))) {
    return getEntryImageFromImageSet(entry.heroImageSet, imageType);
  } else if (get(entry, "heroImageSet.".concat(fallbackImageType, ".url"))) {
    return getEntryImageFromImageSet(entry.heroImageSet, fallbackImageType);
  }
  if ((entry === null || entry === void 0 ? void 0 : entry.__typename) === 'Store' && entry !== null && entry !== void 0 && entry.retailer) {
    return getImageFromEntry(entry.retailer, imageType, fallbackImageType);
  }
  return {
    alt: null,
    src: null,
    imageType: null
  };
};
export const MASTER = ImageTypes.Master;
export const STANDARD = ImageTypes.Standard;
export const SQUARE = ImageTypes.Square;
export default getImageFromEntry;